import yup from '../../../config/yup';

export const textReadValidationSchema = yup.object().shape({
  '@id': yup.string(),
  '@data-type': yup.string().default('format'),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('text'),
  properties: yup.object().shape({
    columnName: yup.string(),
    treatEmptyValuesAsNulls: yup.boolean(),
    inferSchema: yup.boolean(),
    timestampFormat: yup.string(),
    excerptSize: yup.string(),
  }),
});

export const textReadFormSchema = {
  type: 'object',
  properties: {
    '@id': {
      type: 'string',
      title: 'Text ID',
    },
    '@data-type': {
      type: 'string',
      title: 'Data Type',
      default: 'format',
    },
    name: {
      type: 'string',
      title: 'Name',
      pattern: '^[a-zA-Z_$][a-zA-Z0-9_$]*$',
    },
    type: {
      type: 'string',
      title: 'Type',
      default: 'text',
    },
    properties: {
      type: 'object',
      title: 'Properties',
      properties: {
        columnName: {
          type: 'string',
          title: 'Column Name',
        },
        treatEmptyValuesAsNulls: {
          type: 'boolean',
          title: 'Treat Empty Values As Nulls',
        },
        inferSchema: {
          type: 'boolean',
          title: 'Infer Schema',
        },
        timestampFormat: {
          type: 'string',
          title: 'Timestamp Format',
        },
        excerptSize: {
          type: 'string',
          title: 'Excerpt Size',
        },
      },
    },
  },
  required: ['@id', '@data-type', 'name', 'type'],
};

export const textReadFormUiSchema = {
  '@id': {
    'ui:readonly': true,
    'ui:placeholder': 'Auto generated after saving',
  },
  '@data-type': {
    'ui:readonly': true,
  },
  type: {
    'ui:readonly': true,
  },
  treatEmptyValuesAsNulls: {
    'ui:widget': 'checkbox',
  },
  inferSchema: {
    'ui:widget': 'checkbox',
  },
  'ui:submitButtonOptions': {
    props: {
      disabled: false,
      className: 'btn btn-primary',
    },
    norender: false,
    submitText: 'Save',
  },
};

export const textWriteValidationSchema = yup.object().shape({
  '@id': yup.string(),
  '@data-type': yup.string().default('format'),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('text'),
  properties: yup.object().shape({
    columnName: yup.string(),
  }),
});

export const textWriteFormSchema = {
  type: 'object',
  properties: {
    '@id': {
      type: 'string',
      title: 'Format ID',
    },
    name: {
      type: 'string',
      title: 'Name',
      pattern: '^[a-zA-Z_$][a-zA-Z0-9_$]*$',
    },
    type: {
      type: 'string',
      title: 'Type',
      default: 'text',
    },
    properties: {
      type: 'object',
      title: 'Properties',
      properties: {
        columnName: {
          type: 'string',
          title: 'Column Name',
        },
      },
    },
  },
  required: ['name', 'type'],
};

export const textWriteFormUiSchema = {
  '@id': {
    'ui:readonly': true,
    'ui:placeholder': 'Auto generated',
  },
  type: {
    'ui:readonly': true,
  },
  'ui:submitButtonOptions': {
    props: {
      disabled: false,
      className: 'btn btn-primary',
    },
    norender: false,
    submitText: 'Save',
  },
};
